import { Link, NavLink } from "react-router-dom";
import { CATEGORIES } from "@/data/products";
import logo from "@/assets/logo.webp";

export const SiteHeader = () => {
  return (
    <header className="sticky top-0 z-40 w-full border-b border-border bg-background/85 backdrop-blur">
      <div className="container flex h-16 items-center justify-between gap-6">
        <Link to="/" className="flex min-w-0 items-center gap-2 font-semibold text-foreground">
          <img
            src={logo}
            alt="ISDE Meldcode Zoeker logo"
            width={36}
            height={36}
            decoding="async"
            className="h-9 w-9 shrink-0 rounded-lg"
          />
          <span className="min-w-0 leading-tight">
            ISDE <span className="text-primary">Meldcode</span> Zoeker
          </span>
        </Link>
        <nav className="hidden items-center gap-1 text-sm md:flex">
          {CATEGORIES.map((c) => (
            <NavLink
              key={c.slug}
              to={`/categorie/${c.slug}`}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 transition-smooth hover:bg-secondary ${
                  isActive ? "bg-secondary text-primary" : "text-muted-foreground"
                }`
              }
            >
              {c.naam}
            </NavLink>
          ))}
        </nav>
        <Link
          to="/datakwaliteit"
          className="hidden text-xs text-muted-foreground hover:text-primary md:inline"
        >
          Datakwaliteit
        </Link>
      </div>
    </header>
  );
};
